/**
 * Related-party flag, shared by the creditors register and the POD claims
 * schedule.
 *
 * Purpose: relatedness is orthogonal to how a debt ranks — a director's
 * company is still an unsecured creditor — so it reads as its own badge beside
 * the creditor type rather than as another value inside it. What it changes is
 * the scrutiny: a related party's proof wants substantiating before it is
 * admitted, and a related employee's priority is capped.
 *
 * The flag is derived from the Related Parties register by name, so the
 * tooltip always says which party matched and how confident the register is.
 *
 * @component
 * @example
 * <RelatedPartyBadge match={claim.relatedParty} />
 */

import { Badge } from "@/ui/primitives/badge";
import {
  relatedPartyExplanation,
  type RelatedPartyMatchUI,
} from "./relatedPartyShared";

export function RelatedPartyBadge({
  match,
  size = "sm",
}: {
  match: RelatedPartyMatchUI;
  size?: "sm" | "md";
}) {
  return (
    <Badge
      color="pink"
      variant="soft"
      size={size}
      title={relatedPartyExplanation(match)}
    >
      Related
    </Badge>
  );
}
